import React from 'react';

import { Callout, Step } from './shared';

const McpServer: React.FC = () => (
  <div>
    <h2 className="text-2xl font-bold mb-4">MCP Server</h2>
    <p className="text-sm text-base-content/70 mb-5 leading-relaxed">
      The Model Context Protocol (MCP) lets an AI client you already use — Claude Code, Claude Desktop, or claude.ai —
      connect directly to your MFlow account. Once connected, you can ask about your projects, create tasks, or check
      delivery risk from inside that client, without opening MFlow at all.
    </p>

    <h3 className="font-semibold mb-3">Step-by-step</h3>
    <div className="space-y-3 mb-6">
      <Step n={1}>
        Open <strong>Integrations</strong> and find the <strong>MCP Server</strong> card under <strong>AI tools</strong>
        . Copy the server URL shown there.
      </Step>
      <Step n={2}>
        Add it as a connector in your client:
        <ul className="list-disc list-inside mt-2 space-y-1">
          <li>
            <strong>Claude Code</strong> — run{' '}
            <code className="text-xs font-mono bg-base-200 rounded px-1.5 py-0.5">
              claude mcp add --transport http mflow https://mcp.m-flow.io/mcp
            </code>
            , then in a session run <code className="text-xs font-mono bg-base-200 rounded px-1.5 py-0.5">/mcp</code>,
            select <strong>mflow</strong>, and choose <strong>Authenticate</strong>.
          </li>
          <li>
            <strong>Claude Desktop</strong> — open <strong>Settings → Connectors → Add custom connector</strong>, paste
            the URL, and click <strong>Add</strong>.
          </li>
          <li>
            <strong>claude.ai</strong> — open <strong>Customize → Connectors → Add custom connector</strong>, paste the
            URL, and click <strong>Add</strong>.
          </li>
        </ul>
      </Step>
      <Step n={3}>
        A browser tab opens automatically with an MFlow sign-in and consent screen. Sign in (or confirm you&apos;re
        already signed in) and click <strong>Allow access</strong>.
      </Step>
      <Step n={4}>
        Back in your client, <strong>mflow</strong> shows as connected. On claude.ai the connector syncs across Desktop
        and mobile too.
      </Step>
    </div>

    <Callout type="info">
      No API key or client secret to manage — the MFlow server handles sign-in through your existing MFlow account, the
      same OAuth-style consent screen you&apos;d see connecting any other app.
    </Callout>

    <h3 className="font-semibold mt-6 mb-3">What it can do</h3>
    <p className="text-sm text-base-content/70 leading-relaxed">
      The MCP server exposes the same underlying tools as the in-app AI Assistant — reading projects, boards, tasks, and
      metrics, and creating or editing entities when you ask. If you want the full list of what&apos;s callable, it
      mirrors the <strong>Agent Tool Reference</strong> below.
    </p>
  </div>
);

export default McpServer;
